import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import GeneralApiLoading from "../general/GeneralApiLoading";
import QFMainPane from "../general/QFMainPane";
import { CLIENT } from "../store/businesslogic/hardwiredlogic";
import { changeQuestionFlowUserMode } from "../store/components";
import { getCHSdata, getChsDataStatus, filterFormsOrder } from "../store/qf";

const ClientHandOff = () => {
  const { search } = useLocation();
  const dispatch = useDispatch();

  const chsdatastatus = useSelector(getChsDataStatus);
  const encryptedProspectId = search.substring(4);
  const query = new URLSearchParams(search);

  useEffect(() => {
    // add a dispatch here to change the mode to client
    dispatch(changeQuestionFlowUserMode(CLIENT));
    dispatch(getCHSdata({ id: query.get('id') }));
    //dispatch(getCHSdata({ id: encryptedProspectId }));
  }, [dispatch, encryptedProspectId]);

  return (
    <GeneralApiLoading possibleApiValue={chsdatastatus}>
      <QFMainPane></QFMainPane>
    </GeneralApiLoading>
  );
};

export default ClientHandOff;
